import { render, staticRenderFns } from "./FiltersSort.vue?vue&type=template&id=344fb9e4&scoped=true&"
import script from "./FiltersSort.vue?vue&type=script&lang=js&"
export * from "./FiltersSort.vue?vue&type=script&lang=js&"
import style0 from "./FiltersSort.vue?vue&type=style&index=0&id=344fb9e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344fb9e4",
  null
  
)

export default component.exports